import { render } from "./LoginForm.vue?vue&type=template&id=fb3be716&scoped=true&bindings={\"email\":\"data\",\"password\":\"data\",\"loginFormWasValidated\":\"data\",\"requestResetPasswordFormWasValidated\":\"data\",\"resetPasswordEmail\":\"data\",\"postLogin\":\"options\",\"postRequestResetPassword\":\"options\"}"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=fb3be716&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fb3be716"

export default script